import { OwLabel } from "@components/shared/OwLabel/OwLabel";
import OwSelectOption from "@components/shared/OwSelectOption/OwSelectOption";
import ICatalog_Item_Option from "@models/ICatalog_Item_Option";
import IItem_Option from "@models/IItem_Option";
import INewOrder_Item_Option from "@models/INewOrder_Item_Option";
import { IOption } from "@models/IOption";
import ISelectedItemOption from "@models/ISelectedItemOption";

type Props = {
    option: ICatalog_Item_Option;
    selectedItemOptionFn: (options: Partial<INewOrder_Item_Option>) => void;
};

export const OrderItemOption = (props: Props) => {
    const type = props.option.Item_Option?.type;
    const name = props.option.Item_Option?.name || "";
    const required = props.option.Item_Option?.required;

    const selectOptionFn = (option: { value: string; title: string }) => {
        // console.log(option);

        const newOrderItemOption: Partial<INewOrder_Item_Option> = {
            item_option_id: props.option.item_option_id,
            value: option.value,
        };

        console.log("OrderItemOption", newOrderItemOption);

        props.selectedItemOptionFn(newOrderItemOption);
    };

    return (
        <div className={"OrderItemOption"}>
            <OwLabel title={name} skipTranslate={true} />
            {type === "dropdown" && (
                <div>
                    <OwSelectOption
                        options={props.option.Item_Option?.options || []}
                        valueProp={"value"}
                        titleProp={"title"}
                        fn={selectOptionFn}
                        name={name}
                        sizeClass="reg"
                        isRequired={required}
                        emitObject={true}
                    />
                </div>
            )}
        </div>
    );
};
